/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Star: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="star" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M855.0433333333333 888.9300000000001L1302.8233333333333 850.9633333333334L962.7666666666667 556.3533333333334L1064.9366666666665 118.5466666666666L680 350.88L295.12 118.5466666666666L397.2333333333333 556.3533333333332L57.2333333333333 850.9633333333331L505.0133333333333 888.9299999999998L680 1301.86L855.0433333333333 888.9300000000001zM582.7033333333334 781.7733333333333L334.3900000000001 760.75L523.1466666666668 597.2099999999999L466.48 354.3933333333332L680 483.1966666666667L893.4066666666666 354.3933333333332L836.8533333333334 597.2099999999999L1025.5533333333333 760.7499999999999L777.3533333333334 781.7166666666665L680 1011.5L582.7033333333333 781.83z" : "M684.0346666666667 711.144L1042.2586666666666 680.7706666666666L770.2133333333333 445.0826666666666L851.9493333333334 94.8373333333333L544 280.704L236.0960000000001 94.8373333333333L317.7866666666667 445.0826666666666L45.7866666666667 680.7706666666666L404.0106666666666 711.1439999999999L544 1041.488L684.0346666666667 711.144zM466.1626666666667 625.4186666666667L267.5120000000001 608.5999999999999L418.5173333333334 477.7679999999999L373.1840000000001 283.5146666666665L544 386.5573333333333L714.7253333333334 283.5146666666665L669.4826666666668 477.7679999999999L820.4426666666667 608.5999999999999L621.8826666666668 625.3733333333332L544 809.2L466.1626666666667 625.4639999999999z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Star.displayName = `Blueprint5.Icon.Star`;
export default Star;
